export enum EBuildingType {
  BusinessCenter = 1,
  House = 2,
  AdministrativeBuilding = 3,
  MultifunctionalComplex = 4,
  Warehouse = 5,
  FAO = 6,
  Other = 7,
  ShoppingCenter = 8,
  ResidentialBuilding = 9,
  OfficeBuilding = 10,
}
